import delay from './delay';

interface Options {
    attempts?: number;
    minTimeout?: number;
    factor?: number;
    onBeforeTry?: (attempts: number) => void;
}

const retryPromise = async <T>(
    promiseCallback: () => Promise<T>,
    { attempts = 3, minTimeout = 1000, factor = 2, onBeforeTry }: Options = {}
): Promise<T> => {
    let counter = attempts;
    let timeout = minTimeout;
    let error = null;

    while (counter > 0) {
        try {
            if (onBeforeTry) {
                onBeforeTry(counter);
            }
            /* In this case iterations of a loop are dependent of each-other so it makes sense to use await.
             * See details of no-await-in-loop rule where they it's fine to ignore the rule.
             */
            // eslint-disable-next-line no-await-in-loop
            const value = await promiseCallback();
            return value;
        } catch (promiseError) {
            /*
             * In this case iterations of a loop are dependent of each-other so it makes sense to use await.
             * See details of no-await-in-loop rule where they describe when it's fine to ignore the rule.
             */
            // eslint-disable-next-line no-await-in-loop
            await delay(timeout);

            counter -= 1;
            error = promiseError;
            timeout *= factor;
        }
    }

    throw error;
};

export default retryPromise;
